module.exports = __webpack_public_path__ + "img/king.fd6b1be3.svg";